import { observable } from "mobx";
import { api, apiOperacao } from "../../api";
import { toast } from "react-toastify";
import { decodeUtf8String, toast_error } from "../../utils";
import { IEmpresa } from "../../model";

/**
 * Store responsável por gerenciar o estado e requisições relacionadas à NF-e no portal da Fazenda.
 * 
 * Armazena e manipula:
 * - Lista de tarefas NF-e obtidas do backend
 * - Total de tarefas disponíveis
 * - Controle de exibição de erros
 */
export class _NfeFazendaStore {

  /**
   * Estado observável gerenciado pelo MobX.
   */
  obs = observable({
    open_erros: false,
    tasks_portal: [],
    length_tasks_portal: 0
  })

  /**
   * Busca as tarefas da NF-e paginadas no portal da Fazenda.
   * 
   * @async
   * @param paged Número da página a carregar
   * @param cnpj CNPJ da empresa para filtrar as tarefas
   * @returns {Promise<void>} Não retorna valor, mas atualiza o estado observável
   */
  async handleTasksPaged(paged: number, cnpj: string) {

    try {

      let data = {
        cnpj: cnpj,
        page: paged,
        limit: 15
      }

      let resp = await apiOperacao("nfe_fazenda").post("/nfe_fazenda/index", data);

      this.obs.tasks_portal = [];
      this.obs.length_tasks_portal = 0

      if (resp.data.itens.length > 0) {
        this.obs.tasks_portal = resp.data.itens
        this.obs.length_tasks_portal = resp.data.count
      }

    } catch (ex) {

      toast_error(ex, `Erro ao consular tarefas, tente novamente mais tarde.`);

    }

  }

  /**
   * Busca chaves NF-e associadas a uma tarefa.
   * 
   * @async
   * @param page Número da página a carregar
   * @param task_id ID da tarefa
   * @returns {Promise<any[]>} Lista de chaves NF-e ou array vazio caso não encontre
   */
  async handleBuscaChaves(page: number, task_id: string, filter: string) {

    try {

      let data = {
        task_id: task_id,
        page: page,
        limit: 20,
        filter: filter
      }

      let resp = await apiOperacao("nfe_fazenda").post(`/nfe_fazenda/chaves`, data)

      if (resp.status == 200 && resp.data.length) {

        return resp.data

      }

    } catch (ex) { }

    return []

  }

  async download_xml(chave: any, entrada_saida: string, modelo: string, dhemi: string, cnpj: string): Promise<void> {

    try {

      let data = { chave: chave, entrada_saida: entrada_saida, modelo: modelo, dhemi: dhemi, cnpj: cnpj };

      let resp = await apiOperacao("nfe_fazenda").post(`/nfe_fazenda/requisicao-download-xml`, data);

      if (!resp.data.ok) {

        toast.error('Não foi possível realizar o download.', {});
        return

      } else {

        const linkSource = `data:application/xml;base64,${resp.data.base64}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = `${chave}.xml`;
        downloadLink.click();
      }

    } catch (ex) {

      toast_error(ex, `Erro ao realizar download do XML, tente novamente mais tarde.`);

    }

  }

  async view_danfe(data: any, chave: string) {

    try {

      let resp = await apiOperacao("nfe_fazenda").post("/nfe_fazenda/danfe-download", data);

      if (resp.status == 200) {

        let linkSource = `data:application/pdf;base64,${resp.data.base64}`
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = `${chave}.pdf`;
        downloadLink.click();

      } else {

        toast.error(decodeUtf8String(resp.headers.msg), {});

      }

    } catch (ex) {

      toast_error(ex, `Erro ao realizar download da DANFE, tente novamente mais tarde.`);

    }

  }

}

export const NfeFazendaStore = new _NfeFazendaStore();
